import React, { useState } from 'react';
import { Box, Button, Callout, Dialog, Flex, IconButton, Text } from '@radix-ui/themes';
import { ArrowDown, ArrowUp, ChevronsDown, ChevronsUp, GripVertical } from 'lucide-react';

export default function CategoryReorderDialog({categories,onSave,onClose,busy}) {
  const [draft,setDraft]=useState(categories);
  const [dragged,setDragged]=useState('');
  const [saving,setSaving]=useState(false);
  const [error,setError]=useState('');
  const locked=busy||saving;
  const changed=draft.some((name,index)=>name!==categories[index]);
  const move=(name,index)=>{
    if(locked||!draft.includes(name)||index<0||index>=draft.length)return;
    setDraft(previous=>{const next=previous.filter(value=>value!==name);next.splice(index,0,name);return next;});
  };
  const save=async()=>{
    setSaving(true);setError('');
    try{await onSave({category_order:draft});onClose();}
    catch(failure){setError(failure.response?.data?.detail||'Could not save category order. Please try again.');}
    finally{setSaving(false);}
  };
  return <Dialog.Root open onOpenChange={open=>{if(!open&&!saving)onClose();}}><Dialog.Content maxWidth="600px">
    <Dialog.Title>Reorder categories</Dialog.Title>
    <Dialog.Description>Set the order guests see on your QR menu. Drag categories or use the arrows. Changes apply when you save.</Dialog.Description>
    <Box overflowY="auto" mt="4" mb="4" style={{maxHeight:'55vh'}}>
      <Flex asChild direction="column" gap="2"><ol aria-label="Category order" style={{listStyle:'none',padding:0,margin:0}}>
        {draft.map((name,index)=><Flex asChild key={name} align="center" gap="2" p="2" style={{border:'1px solid var(--gray-a5)',borderRadius:6}}><li draggable={!locked} onDragStart={()=>setDragged(name)} onDragEnd={()=>setDragged('')} onDragOver={event=>event.preventDefault()} onDrop={event=>{event.preventDefault();move(dragged,index);setDragged('');}}>
          <GripVertical size={16} aria-hidden="true" style={{flexShrink:0,color:'var(--gray-9)'}}/>
          <Text size="1" color="gray" style={{minWidth:24}}>{index+1}.</Text>
          <Text size="2" style={{flex:1,overflowWrap:'anywhere',minWidth:0}}>{name}</Text>
          <IconButton size="1" variant="ghost" color="gray" aria-label={`Move ${name} to top`} disabled={locked||index===0} onClick={()=>move(name,0)}><ChevronsUp size={15}/></IconButton>
          <IconButton size="1" variant="ghost" color="gray" aria-label={`Move ${name} up`} disabled={locked||index===0} onClick={()=>move(name,index-1)}><ArrowUp size={15}/></IconButton>
          <IconButton size="1" variant="ghost" color="gray" aria-label={`Move ${name} down`} disabled={locked||index===draft.length-1} onClick={()=>move(name,index+1)}><ArrowDown size={15}/></IconButton>
          <IconButton size="1" variant="ghost" color="gray" aria-label={`Move ${name} to bottom`} disabled={locked||index===draft.length-1} onClick={()=>move(name,draft.length-1)}><ChevronsDown size={15}/></IconButton>
        </li></Flex>)}
      </ol></Flex>
    </Box>
    {error&&<Callout.Root color="red" role="alert" mb="4"><Callout.Text>{error}</Callout.Text></Callout.Root>}
    <Flex justify="end" gap="3"><Button variant="soft" color="gray" disabled={saving} onClick={onClose}>Cancel</Button><Button loading={saving} disabled={locked||!changed} onClick={save}>Save order</Button></Flex>
  </Dialog.Content></Dialog.Root>;
}
